module.exports = __webpack_public_path__ + "img/zgsf.99a27776.svg";